import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  link: (props) => ({
    '&, &:visited': {
      color: theme.colors[props._text_color].normal,
    },
    '&:hover': {
      color: theme.colors[props._text_color].hover,
    },
    '&:active': {
      color: theme.colors[props._text_color].active,
    },
  }),
}));

export default useStyle;
